import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-custom-search-input',
  templateUrl: './custom-search-input.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  styleUrls: ['./custom-search-input.component.scss']
})
export class CustomSearchInputComponent implements OnInit {

  @Output() changeInput = new EventEmitter();
  @Output() changeOnkeyup = new EventEmitter();
  @Input() type: any;
  // @Input() formControl: FormControl | any;

  @Input() control: FormControl = new FormControl()


  @Input() inputType: any;
  @Input() labelText: any;
  @Input() placeHolder: any;
  @Input() value: string | undefined;
  @Input() id: any;
  @Input() class: any;
  @Input() inputClass: any;
  @Input() labelClass: any;
  @Input() hasError: boolean = false;
  @Input() required: boolean = false;
  @ViewChild('input') input: any;

  constructor() { }

  ngOnInit(): void {
  }

  change(event:any):void{
    this.changeInput.emit(event.target.value)
  }

  onkeyup(event:any){
    this.changeOnkeyup.emit(event.target.value)
  }

}
